<div class="w-auto p-1">
  <form [formGroup]="formgroup">
    <div class="d-flex justify-space-between align-items-center h-32">
      <span class="subtitle-card text-color-white">
        Tipo de estación
      </span>
      <a class="serch subtitle-card cursor-pointer clean-button" (click)="resetFilter()">
        Limpiar
      </a>
    </div>

    <div class="d-flex fd-col gap-16-px mb-24" style="width: 400px;">
      <span class="subtitle-section text-color-white text-size-18 text-weight-500 lh-20-px">
      </span>

      <div class="d-flex fd-col">
          <mat-chip-listbox formControlName="typeStation" multiple>
            <mat-chip-option *ngFor="let item of SensorsGroupTypes ;let i = index" [value]="item.value">{{item.name}}</mat-chip-option>
          </mat-chip-listbox>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label>indicador</mat-label>
          <mat-select formControlName="indicator">
            <mat-option *ngFor="let item of indicators" [value]="item.id">{{item.value}}</mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>

    <br>

    <div class="footer-buttons">
      <button class="button-apply" (click)="OnFilter()">APLICAR</button>
    </div>
  </form>

</div>
